import { render } from "./transactionList.vue?vue&type=template&id=12683b3a"
import script from "./transactionList.vue?vue&type=script&lang=js"
export * from "./transactionList.vue?vue&type=script&lang=js"

import "./transactionList.vue?vue&type=style&index=0&id=12683b3a&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__